import {
  fetchNetworkContacts,
  addNetworkContact,
  transferNetworkContact,
  updateNetworkContact,
  deleteNetworkContact,
} from '@/api/network-contacts'

export const MUTATION_TYPES = {
  SET_CONTACTS: 'NETWORK_CONTACTS/SET_CONTACTS',
  ADD_CONTACT: 'NETWORK_CONTACTS/ADD_CONTACT',
  REMOVE_CONTACT: 'NETWORK_CONTACTS/REMOVE_CONTACT',
  UPDATE_CONTACT: 'NETWORK_CONTACTS/UPDATE_CONTACT',
  SET_LOADING: 'NETWORK_CONTACTS/SET_LOADING',
}

export const ACTION_TYPES = {
  FETCH: 'NETWORK_CONTACTS/FETCH',
  ADD_CONTACT: 'NETWORK_CONTACTS/ADD_CONTACT',
  TRANSFER_CONTACT: 'NETWORK_CONTACTS/TRANSFER_CONTACT',
  REMOVE_CONTACT: 'NETWORK_CONTACTS/REMOVE_CONTACT',
  UPDATE_CONTACT: 'NETWORK_CONTACTS/UPDATE_CONTACT',
}

export default {
  state: {
    contacts: {},   // keyed by DB id for uniqueness; supports multiple entries per actor (personal + org copies)
    loaded: false,
    loading: false,
  },
  getters: {
    networkContacts (state) {
      return Object.values(state.contacts).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },
    isNetworkContact (state) {
      return (elasticId) => Object.values(state.contacts).some(c => c.elastic_id === elasticId)
    },
    networkContactsLoaded (state) {
      return state.loaded
    },
  },
  mutations: {
    [MUTATION_TYPES.SET_CONTACTS] (state, contacts) {
      state.contacts = Object.fromEntries(contacts.map(c => [c.id, c]))
      state.loaded = true
      state.loading = false
    },
    [MUTATION_TYPES.ADD_CONTACT] (state, contact) {
      state.contacts = { ...state.contacts, [contact.id]: contact }
    },
    [MUTATION_TYPES.REMOVE_CONTACT] (state, elasticId) {
      const updated = { ...state.contacts }
      Object.values(updated).forEach(c => { if (c.elastic_id === elasticId) delete updated[c.id] })
      state.contacts = updated
    },
    [MUTATION_TYPES.UPDATE_CONTACT] (state, contact) {
      const existing = state.contacts[contact.id] ?? {}
      state.contacts = { ...state.contacts, [contact.id]: { ...existing, ...contact } }
    },
    [MUTATION_TYPES.SET_LOADING] (state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async [ACTION_TYPES.FETCH] ({ commit, state }) {
      if (state.loaded) return
      commit(MUTATION_TYPES.SET_LOADING, true)
      try {
        const contacts = await fetchNetworkContacts()
        commit(MUTATION_TYPES.SET_CONTACTS, contacts)
      } catch {
        commit(MUTATION_TYPES.SET_LOADING, false)
      }
    },
    async [ACTION_TYPES.ADD_CONTACT] ({ commit }, { elasticId, name, image, ownerActorId = null }) {
      const contact = await addNetworkContact(elasticId, { ownerActorId })
      commit(MUTATION_TYPES.ADD_CONTACT, { name, image, ...contact })
    },
    async [ACTION_TYPES.TRANSFER_CONTACT] ({ commit }, { elasticId, ownerActorId, duplicate = false }) {
      const contact = await transferNetworkContact(elasticId, ownerActorId, duplicate)
      if (duplicate) {
        commit(MUTATION_TYPES.ADD_CONTACT, contact)
      } else {
        commit(MUTATION_TYPES.UPDATE_CONTACT, contact)
      }
    },
    async [ACTION_TYPES.REMOVE_CONTACT] ({ commit }, elasticId) {
      await deleteNetworkContact(elasticId)
      commit(MUTATION_TYPES.REMOVE_CONTACT, elasticId)
    },
    async [ACTION_TYPES.UPDATE_CONTACT] ({ commit }, { elasticId, phone, notes, contributors_data }) {
      const contact = await updateNetworkContact(elasticId, { phone, notes, contributors_data })
      commit(MUTATION_TYPES.UPDATE_CONTACT, contact)
    },
  },
}
